
$(document).ready(function () {
	var
		ua = navigator.userAgent.toLowerCase(),
		event = (ua.match(/Android/i) || ua.match(/iPad/i) || ua.match(/iPod/i) || ua.match(/iPhone/i)) ? "touchstart" : "click",
		isMobile = ua.match(/(iphone|ipod|ipad|android)/),
		window_w = $(window).width(),
		window_h = $(window).height(),
		is_home = $('body').hasClass('ishome');

	$('html').removeClass('no-js');

	if (("standalone" in window.navigator) && window.navigator.standalone) {
		$('html').addClass('ios-standalone');
	}

	if ($.browser.msie) {
		$('html').addClass('is-ie');
		$('html').addClass('ie-' + $.browser.versionNumber);
	}

	if ($.browser.msedge) {
		$('html').addClass('is-edge');
	}

	if ($.browser.iphone && $.browser.safari) {
		$('html').addClass('ios-safari');
	}

	if ($.browser.iphone && $.browser.chrome) {
		$('html').addClass('ios-chrome');
	}

	if ($.browser.android && $.browser.chrome) {
		$('html').addClass('android-chrome');
	}

	/**
	 * Embed responsive
	 */
	var iframe = $('.text iframe');
	if (iframe.length) {
		iframe.wrap("<div class='embed'></div>");
	}

	/**
	 * Trigger AOS
	 */
	setTimeout(function () {
		$('#loader').fadeOut(500, function () {
			$(this).remove();
		});
	}, 300);

	/**
	 * Lazy load images
	 */
	var velcroLazy = {
		/**
		 * init
		 * run on load and whenever necessary, for example, after an ajax call
		 * elements: pass the class of the elements to be lazy loaded (e.g. .lazy)
		 * ex: velcroLazy.init('.lazy');
		 */
		init: (elements) => {
			let lazyImages = $(elements);

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							var lazyImage = $(entry.target),
								image = lazyImage.find('img')[0] || new Image(),
								is_bg_or_img = typeof lazyImage.data('src') !== 'undefined';

							image.onload = function () {
								if (is_bg_or_img) {//is bg
									lazyImage.css("backgroundImage", "url('" + lazyImage.data("src") + "')").removeAttr('data-src');
								}
								setTimeout(function () {
									lazyImage.addClass('loaded').removeClass("lazy").parent().removeClass('loading');
								}, 200);
							};

							image.src = is_bg_or_img ? lazyImage.data("src") : lazyImage.find('img').attr('data-src');
							lazyImageObserver.unobserve(entry.target);
						}
					});
				});

				lazyImages.each(function () {
					lazyImageObserver.observe(this);
				});
			} else {
				lazyImages.each(function () {
					var is_bg_or_img = typeof $(this).data('src') !== 'undefined';
					if (is_bg_or_img) {//is bg
						$(this).css("backgroundImage", "url('" + $(this).data("src") + "')").removeAttr('data-src');
					} else {//is img
						$(this).find('img').attr("src", $(this).find('img').data("src")).removeAttr('data-src');
					}
					$(this).addClass('loaded').removeClass("lazy").parent().removeClass('loading');
				});
			}
		}
	}

	velcroLazy.init('.lazy');

	var root = $('html,body');
	function smoothScrollingTo(target) {
		var isTour = $('body').hasClass('tour-template-default');
		var offset = isTour ? 0 : $('.navbar-component').outerHeight();
		var target = $(target);
		if (target.length) {
			root.animate({
				scrollTop: target.offset().top - offset
			}, 500, "swing");
		}
	}

	$(document).on('click', 'a[href*=\\#]:not([href*=\\#w-tabs])', function (event) {
		smoothScrollingTo(this.hash);
	});

	/**
	 * Privacy / legal content: build table of contents from [fs-toc-element="contents"] headings (h2–h6)
	 */
	function buildPrivacyTOC() {
		$('.privacy-content-component').each(function () {
			var $comp = $(this);
			var $contents = $comp.find('[fs-toc-element="contents"]');
			var $tocContainer = $comp.find('.privacy-content-link-content');
			if (!$contents.length || !$tocContainer.length) return;

			var usedIds = {};
			function ensureId($el) {
				var id = $el.attr('id');
				if (id) return id;
				var text = $el.text().trim();
				var base = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
				var slug = base;
				var n = 0;
				while (usedIds[slug]) { n++; slug = base + '-' + n; }
				usedIds[slug] = true;
				$el.attr('id', slug);
				return slug;
			}

			var selector = 'h2, h3, h4, h5, h6';
			var headings = [];
			$contents.find(selector).each(function () {
				var $h = $(this);
				var level = parseInt(this.tagName.charAt(1), 10);
				var id = ensureId($h);
				headings.push({ level: level, id: id, text: $h.text().trim() });
			});

			if (!headings.length) return;

			function treeFromHeadings(items) {
				var stack = [];
				var root = { level: 0, children: [] };
				stack.push(root);
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					var node = { level: item.level, id: item.id, text: item.text, children: [] };
					while (stack.length > 1 && stack[stack.length - 1].level >= item.level) stack.pop();
					stack[stack.length - 1].children.push(node);
					stack.push(node);
				}
				return root.children;
			}

			function renderItem(node, isFirst) {
				var level = node.level;
				var isH2 = level === 2;
				var linkClass = 'privacy-content-table-link w-inline-block' + (isH2 ? '' : ' is-h' + level);
				if (isFirst) linkClass += ' current';
				var html = '<div class="privacy-content-link-wrapper is-h' + level + '">';
				html += '<a href="#' + node.id + '" class="' + linkClass + '">';
				html += '<div fs-toc-element="link" class="text-size-medium truncate-width">' + $('<div>').text(node.text).html() + '</div>';
				html += '</a>';
				if (isH2) html += '<div fs-toc-element="ix-trigger" class="privacy-content-h-trigger"></div>';
				if (node.children.length) {
					for (var j = 0; j < node.children.length; j++) {
						html += renderItem(node.children[j], false);
					}
				}
				html += '</div>';
				return html;
			}

			var tree = treeFromHeadings(headings);
			var tocHtml = '';
			for (var k = 0; k < tree.length; k++) {
				tocHtml += renderItem(tree[k], k === 0);
			}
			$tocContainer.empty().append(tocHtml);

			// Scroll spy: highlight TOC link when its heading reaches the middle of the viewport
			var $headingEls = $contents.find(selector);
			function setCurrentTOCLink() {
				var viewportCenterY = window.innerHeight / 2;
				var currentId = null;
				$headingEls.each(function () {
					var rect = this.getBoundingClientRect();
					if (rect.top <= viewportCenterY) currentId = this.id;
				});
				$tocContainer.find('a.privacy-content-table-link').each(function () {
					if (this.getAttribute('href') === '#' + currentId) {
						$(this).addClass('current');
					} else {
						$(this).removeClass('current');
					}
				});
			}
			var spyObserver = new IntersectionObserver(function () {
				setCurrentTOCLink();
			}, {
				root: null,
				rootMargin: '-50% 0px -50% 0px',
				threshold: 0
			});
			$headingEls.each(function () { spyObserver.observe(this); });
			setCurrentTOCLink(); // set initial state
		});
	}

	if ($('.section-privacy-content').length) {
		buildPrivacyTOC();
	}

	smoothScrollingTo(location.hash);

	if (!Modernizr.objectfit) {
		$('body .objectfit').each(function () {
			var $container = $(this),
				imgUrl = $container.find('img').prop('src');
			if (imgUrl) {
				$container
					.css('backgroundImage', 'url(' + imgUrl + ')')
					.addClass('compat-object-fit');
			}
		});
	}

	$(".slider-main_component").each(function (index) {
		let loopMode = false;
		if ($(this).attr("loop-mode") === "true") loopMode = true;
		let sliderDuration = 300;
		if ($(this).attr("slider-duration") !== undefined) {
			sliderDuration = +$(this).attr("slider-duration");
		}
		// --- Swiper Highlight
		const swiperHighlight = new Swiper($(this).find(".swiper.is-home-highlight")[0], {
		speed: 500,
		slidesPerView: 1,
		spaceBetween: 0,
		rewind: false,
		loop: true,
		//watchOverflow: true,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		slideToClickedSlide: true,
			pagination: {
			el: $(this).find(".swiper-bullet-wrapper.is-home-highlight")[0],
			bulletActiveClass: "is-active",
			bulletClass: "swiper-bullet",
			bulletElement: "button",
			clickable: true,
			},
			navigation: {
			nextEl: $(this).find(".swiper-next")[0],
			prevEl: $(this).find(".swiper-prev")[0],
			disabledClass: "is-disabled"
			},
			slideActiveClass: "is-active",
			slideDuplicateActiveClass: "is-active"
		});
	});

	const modalSystem = ((window.lumos ??= {}).modal ??= {
		list: {}, open(id) { this.list[id]?.open?.(); }, closeAll() { Object.values(this.list).forEach((m) => m.close?.()); },
	});
	function createModals() {
		document.querySelectorAll(".modal_dialog").forEach(function (modal) {
		if (modal.dataset.scriptInitialized) return;
		modal.dataset.scriptInitialized = "true";
		const modalId = modal.getAttribute("data-modal-target");
		let lastFocusedElement;
		if (typeof gsap !== "undefined") {
			gsap.context(() => {
				let tl = gsap.timeline({ paused: true, onReverseComplete: resetModal });
				tl.fromTo(modal, { opacity: 0 }, { opacity: 1, duration: 0.3, ease: "power1.out" });
				if(modal.querySelector('.modal_content').classList.contains('is-side')){
					tl.from(".modal_content.is-side", { x: "6rem", duration: 0.3, ease: "power1.out" }, "<");
				} else{
					tl.from(".modal_content", { y: "6rem", duration: 0.3, ease: "power1.out" }, "<");
				}
				modal.tl = tl;
			}, modal);
		}
		function resetModal() {
			typeof lenis !== "undefined" && lenis.start ? lenis.start() : (document.body.style.overflow = "");
			modal.close();
 			if (lastFocusedElement) lastFocusedElement.focus();
			window.dispatchEvent(new CustomEvent("modal-close", { detail: { modal } }));
		}
		function openModal() {
			typeof lenis !== "undefined" && lenis.stop ? lenis.stop() : (document.body.style.overflow = "hidden");
			lastFocusedElement = document.activeElement;
			modal.showModal();
			if (typeof gsap !== "undefined") modal.tl.play();
			modal.querySelectorAll("[data-modal-scroll]").forEach((el) => (el.scrollTop = 0));
			window.dispatchEvent(new CustomEvent("modal-open", { detail: { modal } }));
		}
		function closeModal() {
			typeof gsap !== "undefined" ? modal.tl.reverse() : resetModal();
		}
		if (new URLSearchParams(location.search).get("modal-id") === modalId) openModal(), history.replaceState({}, "", ((u) => (u.searchParams.delete("modal-id"), u))(new URL(location.href)));
		modal.addEventListener("cancel", (e) => (e.preventDefault(), closeModal()));
		modal.addEventListener("click", (e) => e.target.closest("[data-modal-close]") && closeModal());
		document.addEventListener("click", (e) => e.target.closest("[data-modal-trigger='" + modalId + "']") && openModal());
			modalSystem.list[modalId] = { open: openModal, close: closeModal };
		});
	}
	createModals();

	document.addEventListener( 'wpcf7mailsent', function( event ) {
		document.querySelectorAll("form.wpcf7-form > :not(.wpcf7-response-output)").forEach(el => {
		  el.style.display = 'none';
		  $('.form_message-success-wrapper').show();
		});
	  }, false );

	  $('.w-nav-button').click(function () {
		const $logo = $('.navbar-logo-link');
		// find existing theme class
		let themeClass = $logo.attr('class').split(' ').find(c => c.startsWith('theme'));
		if ($(this).hasClass('w--open')) {
		  // NAV IS CLOSING → restore previous theme
		  if ($logo.data('prev-theme')) {
			$logo.removeClass('theme-hover-white').addClass($logo.data('prev-theme'));
		  }
		} else {
		  // NAV IS OPENING → swap to white
		  if (themeClass && themeClass !== 'theme-hover-white') {
			$logo.data('prev-theme', themeClass);
			$logo.removeClass(themeClass);
		  }
		  $logo.addClass('theme-hover-white');
		}
	  });

	  /**
	   * Modal Trigger Animation on Footer Scroll
	   * Hide/show modal trigger button when reaching footer
	   */
	  function initModalTriggerAnimation() {
		const $modalTrigger = $('[data-modal-trigger]');
		const $footer = $('.footer');
		
		if (!$modalTrigger.length || !$footer.length) return;
		
		let isHidden = false;
		
		// Add CSS transition for smooth animation
		$modalTrigger.css({
			'transition': 'transform 0.3s ease, opacity 0.3s ease',
			'transform-origin': 'center'
		});
		
		function checkFooterVisibility() {
			const footerElement = $footer[0];
			const footerRect = footerElement.getBoundingClientRect();
			const windowHeight = window.innerHeight;
			
			// Alternative: Check if we're near the bottom of the page
			const documentHeight = $(document).height();
			const scrollTop = $(window).scrollTop();
			const scrollBottom = scrollTop + windowHeight;
			const nearBottom = scrollBottom > documentHeight - 200; // 200px from bottom
			
			// Hide when footer is visible OR when near bottom of page
			const shouldHide = footerRect.top < windowHeight || nearBottom;
			
			if (shouldHide && !isHidden) {
				// Hide the modal trigger
				$modalTrigger.css({
					'transform': 'scale(0)',
					'opacity': '0',
					'pointer-events': 'none'
				});
				isHidden = true;
			} else if (!shouldHide && isHidden) {
				// Show the modal trigger
				$modalTrigger.css({
					'transform': 'scale(1)',
					'opacity': '1',
					'pointer-events': 'auto'
				});
				isHidden = false;
			}
		}
		
		// Initial check
		checkFooterVisibility();
		
		// Listen for scroll events with throttling
		let scrollTimer = null;
		$(window).on('scroll', function() {
			if (scrollTimer) clearTimeout(scrollTimer);
			scrollTimer = setTimeout(checkFooterVisibility, 10);
		});
		
		// Listen for resize events
		$(window).on('resize', checkFooterVisibility);
	  }
	  
	  // Initialize modal trigger animation
	  initModalTriggerAnimation();

});

/**
 * Block scroll
 * @param block
 */
function blockScroll(block) {
	if (block == 1) {
		$('html').addClass('block-scroll');
	} else if (block == 0) {
		$('html').removeClass('block-scroll');
	}
}

// Disable Webflow smooth scroll
var Webflow = Webflow || [];
Webflow.push(function () {
	$(function () {
		$(document).off('click.wf-scroll');
	});
});

//newsletter form
var Webflow = Webflow || [];
Webflow.push(function () {

	// === Custom Form Handling ===

	// unbind webflow form handling
	$(document).off('submit');

	$("#email-form").on('submit', function (event) {
		event.preventDefault();

		var $this = $(this);

		const formData = new FormData(this);

		const formObject = Object.fromEntries(formData.entries());

		const submit_btn = $('#newsletter-submit');

		fetch($(this).attr("action"), {
			method: "POST",
			body: formData,
		}).then((response) => response.json())
			.then(function (response) {
				// The API call was successful!
				submit_btn.attr('value', 'Enviar').attr('disabled', false);
				if (response.success) {
					$this.hide();
					$this.parent().find('.w-form-done').show();
				} else {
					$this.parent().find('.w-form-fail').text(response.message).show();
				}

			}).catch(function (error) {
				// There was an error
				submit_btn.attr('value', 'Enviar').attr('disabled', false);
				$this.parent().find('.w-form-fail').text(error.message).show();
			});
	});
});
